import {connect} from 'react-redux';
import {actions} from '@/AutoSave';
import UI from './ConnectionFailureAlertUI';

var mapStateToProps = (state, ownProps) => {
    return {
        activeSavesCount: state.autoSave.activeSavesCount,
        failedSavesCount: state.autoSave.failedSavesCount,
        connectionLost: state.app.connection_lost,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        retrySave: () => dispatch(actions.incrementActiveSaves()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UI);
